var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"single-video"},[_c('vue-plyr',{ref:"plyr",attrs:{"options":_vm.plyrOptions,"crossorigin":true}},[_c('div',{attrs:{"data-plyr-provider":"youtube","data-plyr-embed-id":_vm.pid}})])],1)}
var staticRenderFns = []

export { render, staticRenderFns }